module.exports = __webpack_public_path__ + "img/fearitself.2987a153.svg";